export const GenericActions = {
    DETAIL_LOADED: "DETAIL_LOADED",
    LIST_LOADED: "LIST_LOADED",
    STATE_RESET: "STATE_RESET",
    VALUE_CHANGED: "VALUE_CHANGED",
    VALUE_ADDED: "VALUE_ADDED",
    DISPLAY_TOGGLED: "DISPLAY_TOGGLED",
    TOGGLE_SELECT: "TOGGLE_SELECT",
    SELECT_ONE: "SELECT_ONE",
    SELECT_ALL: "SELECT_ALL",
    DESELECT_ALL: "DESELECT_ALL",
    COMPONENT_ADDED: "COMPONENT_ADDED",
    COMPONENT_REMOVED: "COMPONENT_REMOVED",
    PERMISSION_DENIED: "PERMISSION_DENIED",
};
